// Subtle "tapped tile fades in place" tap effect. Web Animations API,
// short-circuits under prefers-reduced-motion. Mirrors the reduced-motion
// guard pattern used in flyStar/spawnSparkles.

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

function prefersReducedMotion(): boolean {
  const w = globalThis.window as Window | undefined;
  if (!w || typeof w.matchMedia !== 'function') return false;
  try {
    return w.matchMedia(REDUCED_MOTION_QUERY).matches;
  } catch {
    return false;
  }
}

export interface ShrinkFadeOptions {
  durationMs?: number;
}

export function shrinkFade(target: HTMLElement, options: ShrinkFadeOptions = {}): void {
  const { durationMs = 250 } = options;
  if (prefersReducedMotion()) {
    target.style.opacity = '0';
    target.style.transform = 'scale(0.6)';
    return;
  }

  if (typeof target.animate !== 'function') {
    target.style.opacity = '0';
    target.style.transform = 'scale(0.6)';
    return;
  }

  target.animate(
    [
      { transform: 'scale(1)', opacity: 1 },
      { transform: 'scale(0.6)', opacity: 0 },
    ],
    {
      duration: durationMs,
      easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
      fill: 'forwards',
    },
  );
}
